// NOTE: 初回リリースには検索機能を含めない
import { useState } from 'react'

import { ResizableLayout } from '@/components/layouts'
import { InquiryList } from '@/components/shared/InquiryList'
import { Box, PaginationRootProps } from '@/components/ui'
import { useGqlQuerySuspense } from '@/lib/api'
import { useBreakpointValue } from '@/lib/chakra-ui'
import { graphql } from '@/lib/gql'
import { TrialsOrder } from '@/lib/gql/graphql'

import { SPTrialList, TrialList } from './TrialList'

const getTrialListQuery = graphql(`
  query GetTrialList($page: Int!, $per: Int!, $order: TrialsOrder!) {
    trials(input: { page: $page, per: $per, order: $order }) {
      ...TrialList
    }
  }
`)

export const TrialListPage = () => {
  const [currentPage, setCurrentPage] = useState(1)

  const pageChangeHandler: PaginationRootProps['onPageChange'] =
    pageChangeDetail => {
      setCurrentPage(pageChangeDetail.page)
    }

  const { data } = useGqlQuerySuspense({
    document: getTrialListQuery,
    variable: {
      page: currentPage,
      per: 20,
      order: TrialsOrder.PublishedAtDescProgressAsc,
    },
  })

  const renderSPMode = useBreakpointValue({ base: true, desktop: false })

  if (renderSPMode) {
    return (
      <SPTrialList
        trials={data.trials}
        pageChangeHandler={pageChangeHandler}
        inquiryArea={<InquiryList listTitle="すべての問い合わせ" />}
      />
    )
  }

  return (
    <ResizableLayout
      mainContent={
        <TrialList trials={data.trials} pageChangeHandler={pageChangeHandler} />
      }
      resizableContent={
        // ヘッダー分の高さを引いてstickyで固定する
        <Box h="full" position="sticky" top={0}>
          <InquiryList listTitle="すべての問い合わせ" />
        </Box>
      }
    />
  )
}
